import { createContext, useState, ReactNode } from 'react';

// 1. (Opsional tapi Sangat Direkomendasikan) Definisikan bentuk soal yang sudah bersih
export interface SanitizedQuestion {
  id: number;
  questionNumber: number;
  question: string;
  choices: string[];
  explanation: string;
}

// 2. Definisikan BENTUK (Type) dari Context kita secara eksplisit
export interface TryoutContextType {
  currentQuestion: SanitizedQuestion | null;
  // Ini adalah tipe yang benar untuk setter dari useState!
  setCurrentQuestion: React.Dispatch<React.SetStateAction<SanitizedQuestion | null>>;
}

// 3. Buat Context dengan kontrak yang BENAR dan nilai default yang sesuai
export const TryoutContext = createContext<TryoutContextType>({
  currentQuestion: null,
  setCurrentQuestion: () => {}, // Fungsi kosong ini sudah sesuai dengan tipe Dispatch (menerima argumen, tidak mengembalikan apa-apa)
});

// 4. (Opsional tapi Direkomendasikan) Beri tipe pada props children
interface TryoutProviderProps {
  children: ReactNode;
}

export const TryoutProvider = ({ children }: TryoutProviderProps) => {
  // Beri tipe pada state Anda untuk keamanan maksimum
  const [currentQuestion, setCurrentQuestion] = useState<SanitizedQuestion | null>(null);

  // 'value' sekarang 100% cocok dengan 'TryoutContextType'
  const value = { currentQuestion, setCurrentQuestion };

  return (
    <TryoutContext.Provider value={value}>
      {children}
    </TryoutContext.Provider>
  );
};